{
  "en": {
    "datatable": {
      "actions": {
        "bulk_action": "Bulk action",
        "bulk_edit": "Bulk edit",
        "clear_filters": "Clear filters",
        "deselect_all": "Deselect all",
        "select_all": "Select all"
      },
      "labels": {
        "gridlines": "Grid lines",
        "size": "Size",
        "toggle_columns": "Toggle columns"
      }
    }
  }
}